import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { filter, flatMap } from 'rxjs/operators';
import { IPayment, PaymentStatus } from 'src/app/model/billing/IPayment';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { UUID } from 'angular2-uuid';
import { BillingService } from 'src/app/core/services/billing.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { IPaymentHistoryComponent } from 'src/app/model/sitefinity/IBillingAndPayment';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['TransactionDateTime', 'Amount', 'PaymentMethodName', 'Status'];
  payments: IPayment[] = null;
  pagedPaymentList: IPayment[] = null;
  paymentsDataSource = new MatTableDataSource<IPayment>();

  @ViewChildren('desktopPaginator')
  paginator: QueryList<MatPaginator>;

  @ViewChildren(MatSort)
  sort: QueryList<MatSort>;

  @ViewChild('container', { read: ElementRef }) container: ElementRef;

  pageSize: number = 0;

  trackingId = UUID.UUID();

  constructor(
    private loggedInUserSettings: LoggedInUserSettings,
    private billingService: BillingService,
    private settings: PreInitSettingsService,
    private resourceService: ADPResourceService
  ) {


  }

  ngAfterViewInit(): void {
    this.paginator.changes.subscribe((paginators) => {
      this.paymentsDataSource.paginator = paginators.first;
    });

    this.sort.changes.subscribe(sortList => {
      this.paymentsDataSource.sort = sortList.first;
    });
  }

  ngOnInit(): void {
    const clientId = this.settings.getSettings().middleWare.clientId;
    const associateNumber = this.settings.getSettings().middleWare.associateNumber;
    const programCode = this.settings.getSettings().middleWare.programCode;
    this.pageSize = parseInt(this.resourceService.getPortalSetting('Payment_History_Page_Size').Value);
    this.loggedInUserSettings.$selectedContract
      .pipe(
        filter((contract: ISelectedContract) => contract !== null),
        flatMap((contract: ISelectedContract) => this.billingService.getPaymentHistory(
          contract.id,
          programCode,
          clientId,
          this.trackingId,
          associateNumber))
      ).subscribe((payments: IPayment[]) => {
        this.payments = payments;
        this.pagedPaymentList = payments.slice(0, this.pageSize > payments.length ? payments.length : this.pageSize);
        this.paymentsDataSource.data = payments;
      });
  }

  onPageChange(event: PageEvent) {
    const startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;

    if (endIndex > this.payments.length) {
      endIndex = this.payments.length;
    }

    this.pagedPaymentList = this.payments.slice(startIndex, endIndex);

    this.container.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  formatStatus(status: number) {
    const validStatuses = [
      PaymentStatus.Pending,
      PaymentStatus.Success,
      PaymentStatus.Declined
    ];

    if (!validStatuses.includes(status)) {
      return '';
    }

    return PaymentStatus[status].replace(/([A-Z])/g, ' $1');
  }
}
